import { api } from "../../../services/apiClient";
import type {
  CreateFolderRequest,
  FolderChildrenResponse,
  FolderDeletePreview,
  FolderDeleteResult,
  FolderSummary,
  FolderTreeNode,
  RenameFolderRequest,
} from "../types/project-storage.types";
import { projectStorageBasePath } from "./paths";

/** E01 — GET /projects/:mmCode/folders/tree */
export async function getFolderTree(mmCode: number): Promise<FolderTreeNode[]> {
  const { data } = await api.get<FolderTreeNode[]>(
    `${projectStorageBasePath(mmCode)}/folders/tree`
  );
  return data;
}

/** E02 — GET /projects/:mmCode/folders/:folderId/children */
export async function getFolderChildren(
  mmCode: number,
  folderId: string
): Promise<FolderChildrenResponse> {
  const { data } = await api.get<FolderChildrenResponse>(
    `${projectStorageBasePath(mmCode)}/folders/${folderId}/children`
  );
  return data;
}

/** E03 — POST /projects/:mmCode/folders */
export async function createFolder(
  mmCode: number,
  body: CreateFolderRequest
): Promise<FolderSummary> {
  const { data } = await api.post<FolderSummary>(
    `${projectStorageBasePath(mmCode)}/folders`,
    body
  );
  return data;
}

/** E04 — PATCH /projects/:mmCode/folders/:folderId */
export async function renameFolder(
  mmCode: number,
  folderId: string,
  body: RenameFolderRequest
): Promise<FolderSummary> {
  const { data } = await api.patch<FolderSummary>(
    `${projectStorageBasePath(mmCode)}/folders/${folderId}`,
    body
  );
  return data;
}

/** E05 — GET /projects/:mmCode/folders/:folderId/delete-preview */
export async function getFolderDeletePreview(
  mmCode: number,
  folderId: string
): Promise<FolderDeletePreview> {
  const { data } = await api.get<FolderDeletePreview>(
    `${projectStorageBasePath(mmCode)}/folders/${folderId}/delete-preview`
  );
  return data;
}

/** E06 — DELETE /projects/:mmCode/folders/:folderId */
export async function deleteFolder(
  mmCode: number,
  folderId: string,
  confirmCascade = false
): Promise<FolderDeleteResult> {
  const { data } = await api.delete<FolderDeleteResult>(
    `${projectStorageBasePath(mmCode)}/folders/${folderId}`,
    {
      params: confirmCascade ? { confirmCascade: "true" } : undefined,
    }
  );
  return data;
}
